import { React } from "react";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import { addNewUser, getSingleUserData } from "../../utils";

const SignInSide = () => {
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    try {
      const result = await signInWithPopup(auth, provider);
      const dbUserData = await checkIfUserExist(result.user);
      if (!dbUserData || dbUserData.length === 0) {
        await handleAddNewUser(result.user.uid);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFacebookSignIn = async () => {
    const provider = new FacebookAuthProvider();
    const auth = getAuth();

    try {
      const result = await signInWithPopup(auth, provider);
      await handleAddNewUser(result.user.uid);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddNewUser = async (uid) => {
    try {
      await addNewUser(uid);
    } catch (error) {
      console.error(error);
    }
  };

  const checkIfUserExist = async (user) => {
    const dbUserData = await getSingleUserData(user);
    return dbUserData;
  };

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className=" md:flex md:w-4/7 bg-cover bg-center bg-white rounded-lg">
        <div className="flex-1 flex flex-col justify-center p-20">
          <div className="mx-auto max-w-sm">
            <div className="text-center">
              <svg
                className="w-16 h-16 mx-auto text-indigo-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Agrega el contenido del icono si es necesario */}
              </svg>
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                Inicio de sesión
              </h2>
            </div>
            <button
              onClick={handleGoogleSignIn}
              className="mt-4 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="mr-2">Iniciar sesión con Google</span>
            </button>
            <button
              onClick={handleFacebookSignIn}
              className="mt-4 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span className="mr-2">Iniciar sesión con Facebook</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInSide;
